(function (Drupal, once) {
  Drupal.behaviors.orgAutocomplete = {
    attach(context) {
      // Scope only to inputs we marked in YAML: class="org-autocomplete".
      once('org-autocomplete', 'input.org-autocomplete', context).forEach(function (el) {
        var $ = window.jQuery;
        if (!$) return;

        // Remove trailing " (123)" suffix from the textbox.
        function strip() {
          el.value = el.value.replace(/\s+\(\d+\)\s*$/, '');
        }

        // Run strip several times to beat any late handlers (core rewrites value on select/change).
        function stripSoon() {
          strip();
          setTimeout(strip, 0);
          setTimeout(strip, 50);
          if (window.requestAnimationFrame) requestAnimationFrame(strip);
        }

        // jQuery UI events fired by the autocomplete widget:
        $(el).on('autocompleteselect autocompletechange', stripSoon);

        // Normal form events—catch manual edits/back-button/prefill:
        $(el).on('input change blur', strip);

        // First render (handles prefilled values):
        strip();
      });
    }
  };
})(Drupal, once);
